<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller"/>
    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Estadísticas de asociaciones JATO</h1>
              <p class="text-white mt-0 mb-5">Registros actualizados por usuarios</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row mb-20">
        <div class="col-sm-12">
          <div class="card card-body">
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <label for>Buscar usuario</label>
                  <v-select
                    multiple
                    label="caption"
                    :options="usuarios"
                    style="width:100%"
                    placeholder="Buscar por nombre o email"
                    :disabled="loading"
                  >
                    <span slot="no-options">No hay resultados disponibles</span>
                  </v-select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <label for>Fecha Inicial</label>
                  <input type="date" class="form-control form-control-alternative">
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <label for>Fecha Final</label>
                  <input type="date" class="form-control form-control-alternative">
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <button class="btn btn-success mt-30" type="button">Buscar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20">
        <div class="col-sm-3">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">Asociados</h5>
                  <span class="h1 font-weight-bold mb-0">350</span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-success text-white p-1 text-small shadow">JATO</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">Pendientes</h5>
                  <span class="h1 font-weight-bold mb-0">10</span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-danger text-white p-1 text-small shadow">No JATO</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">Aprobados</h5>
                  <span class="h1 font-weight-bold mb-0">50</span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-warning text-white p-1 text-small shadow">Premium</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">Global</h5>
                  <span class="h1 font-weight-bold mb-0">400<span class="text-muted text-small">/5674</span></span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape p-1 h1 text-info shadow"><i class="ni ni-world"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <!-- COMPONENTE PRINCIPAL -->
          <div class="row">
            <div class="col-xl-8 mb-5 mb-xl-0">
              <div class="card shadow">
                <div class="card-header border-0">
                  <div class="row align-items-center">
                    <div class="col">
                      <h4 class="mb-0">Usuarios</h4>
                    </div>
                    <div class="col text-right">
                      <a href="#!" class="btn btn-sm btn-primary">Ver todos</a>
                    </div>
                  </div>
                </div>

                <div class="accordion" id="accordionExample">
                  <div class="card" v-for="(user, userIndex) in usuarios" :key="'user_' + user.id">
                    <div class="card-header" id="headingOne">
                      <h2 class="mb-0">
                        <button
                          class="btn btn-link text-left"
                          type="button"
                          data-toggle="collapse"
                          :data-target="'#collapse'+ userIndex "
                          aria-expanded="false"
                          :aria-controls="'collapse'+ userIndex"
                        >{{user.nombre}}<br><span class="text-primary text-small">15 procesados</span> </button>
                      </h2>
                    </div>

                    <div
                      :id="'collapse'+ userIndex "
                      class="collapse"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body1">
                        <div class="table-responsive">
                          <!-- Projects table -->
                          <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                              <tr>
                                <th></th>
                                <th scope="col" class="text-center">Registros</th>
                                <th scope="col" class="text-right">Fecha</th>
                                <th scope="col" class="text-center">Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="reg in registros" :key="'key_'+reg.id">
                                <td>
                                  <p class="mb-0">{{ reg.marca }} {{ reg.modelo }} {{ reg.version }} <span class="text-small text-muted" v-if="reg.estatus == 1"><i class="fas fa-exchange-alt text-success" title="asociado con"></i> {{ reg.version }}</span></p>
                                  <span class="badge" :class="getStatus(reg.estatus).class" v-text="getStatus(reg.estatus).text"></span>
                                </td>
                                <td class="text-center">{{ reg.count }}</td>
                                <td class="text-right text-capitalize">{{ reg.fecha | formatDate }}</td>
                                <td class="text-center">
                                    <button v-if="reg.estatus != 3" class="btn btn-secondary btn-sm" title="Eliminar asociación"><i class=" fas fa-trash text-danger"></i></button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-4">
                <div class="card">
                    <div class="car">

                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/helpers/utils";
export default {
  name: "estadisticas",
  data() {
    return {
      loading: false,
      controller: {
        title: "Operaciones",
        mainRouter: "/"
      },
      usuarios: [
        {
          id: 1,
          nombre: "Davie Losemann",
          email: "dlosemann0@google.it"
        },
        {
          id: 2,
          nombre: "Marissa Hillburn",
          email: "mhillburn1@ft.com"
        },
        {
          id: 3,
          nombre: "Basia Rigg",
          email: "brigg2@nih.gov"
        },
        {
          id: 4,
          nombre: "Link Fragino",
          email: "lfragino3@gnu.org"
        },
        {
          id: 5,
          nombre: "Francklyn Calafate",
          email: "fcalafate4@youtube.com"
        }
      ],
      registros: [
        {
          id: 1,
          marca: "Infiniti",
          modelo: "QX56",
          version: "LT 1.4",
          count: 3,
          fecha: "2019-01-22T08:34:28Z",
          estatus: 1
        },
        {
          id: 2,
          marca: "Volkswagen",
          modelo: "Jetta",
          version: "LT 1.2",
          count: 24,
          fecha: "2019-03-05T05:50:44Z",
          estatus: 3
        },
        {
          id: 3,
          marca: "Mercury",
          modelo: "Mountaineer",
          version: "LT 1.2",
          count: 5,
          fecha: "2019-02-17T11:44:10Z",
          estatus: 2
        },
        {
          id: 4,
          marca: "Toyota",
          modelo: "Tacoma Xtra",
          version: "1.4 SPORT LS",
          count: 10,
          fecha: "2019-01-28T19:40:04Z",
          estatus: 1
        },
        {
          id: 5,
          marca: "Mitsubishi",
          modelo: "Eclipse",
          version: "1.4 SPORT LS",
          count: 21,
          fecha: "2019-03-07T17:59:19Z",
          estatus: 1
        }
      ]
    };
  },
  filters: {
    formatDate(val) {
      return utils.formatDate(val);
    }
  },
  methods: {
      getStatus(val) {
          switch (val) {
              case 1:
                  return { class: 'badge-success', text: 'Asociado' }

              case 2:
                  return { class: 'badge-warning', text: 'Aprobado' }

              case 3:
                  return { class: 'badge-danger', text: 'Pendiente' }
          
              default:
              return { class: 'badge-default', text: 'No especificado' }
                  break;
          }
      }
  }
};
</script>